window.INKIVE = window.INKIVE || { C: {} };

INKIVE.C.BOOK_TYPE = {
  DESIGN: '0',
  LOGO: '1',
  TEMPLATE: '2',
  RESTRICTED_DESIGN: '3',
  DESYGNER_DESIGN: '4'
};

INKIVE.C.UPLOAD_SERVER = 'https://s3.amazonaws.com/virginia.inkive.com';

INKIVE.C.CTRL = INKIVE.C.BASE_URL + 'editor/';

INKIVE.C.AUTO_SAVE_INTERVAL = 60 * 1000 * 5;

INKIVE.C.EMBED = {
  W2H: 0.707070707070707,
  DefaultWidth: 290,
  MaxWidth: 1200
};

INKIVE.C.EMBED.MaxHeight = Math.round(INKIVE.C.EMBED.MaxWidth * INKIVE.C.EMBED.W2H);
INKIVE.C.EMBED.DefaultHeight = Math.round(INKIVE.C.EMBED.DefaultWidth * INKIVE.C.EMBED.W2H);

INKIVE.C.Timeout = {
  imageCheck: 180 * 1000
};

INKIVE.C.Status = {
  success: 0,
  error: 1,
  timeout: 10
};

INKIVE.C.USE_FALLBACK_UPLOAD = true;
INKIVE.C.DEFAULT_FINEUPLOADER = {
  maxConnections: 3,
  uploaderType: 'basic',
  signature: { endpoint: INKIVE.C.BASE_URL + 'upload' },
  iframeSupport: { localBlankPagePath: INKIVE.C.BASE_URL + 'assets/blank.html' },
  chunking: { enabled: false },
  resume: { enabled: true },
  validation: { sizeLimit: 150000000 },
  messages: {},
  request: {
    endpoint: INKIVE.C.UPLOAD_SERVER,
    accessKey: INKIVE.C.UPLOAD_KEY,
    forceMultipart: false
  },
  uploadSuccess: {
    endpoint: INKIVE.C.BASE_URL + 'upload/successasync',
    params: {
      type: 'editor',
      scrapbookId: INKIVE.C.BOOK ? INKIVE.C.BOOK.id : null
    }
  }
};

// ---- Size -----------------------------------------------------------------------------------------------------------

INKIVE.C.VersionUploadSize = {
  o: 0,
  l: 3500,
  m: 1800,
  s: 600
};

INKIVE.C.VersionThumbSize = {
  o: 1200,
  l: 1024,
  m: 800,
  s: 600
};

// ---- Defaults -------------------------------------------------------------------------------------------------------
INKIVE.C.DefaultColors = [
  '#FFFFFF', '#AAAAAA', '#555555', '#000', 'none',
  '#D42929', '#00AEEF', '#00A651', '#F5EB33'
];

// ---- HTML -----------------------------------------------------------------------------------------------------------
INKIVE.C.THUMB_NOCOVER = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAABMCAYAAABqFkmCAAACKklEQVR4Xu2bUXJEUBREx9pYtjXZgkQSU0qhH4N0qzNfmbnjaue4z5uPVF3X9S9eEQQqZEV4+gmJrBxXyApyhSxkJREIysozC1lBBIKiMlnICiIQFJXJQlYQgaCoTBaygggERWWykBVEICgqk4WsIAJBUZksZAURCIrKZCEriEBQVCYLWUEEgqIyWcgKIhAUlclCVhCBoKhMFrKCCARFZbKQFUQgKOrlk9W27RtH0zTvv8fPp58d5TY9x9jjjL5H81x1XLysJeln3ghXgT/S91ZZQ8Dxjj8D6Bk9jkD7r2OsZM2XM7WU7ZG11XveZ+390hI7fLeqqlff//63r8r8iejbZA0XMYVQCmjr4ktl7T3XkZxXixr6I+sbwpbMEtHDZNV1/cnQFB17q6wh0dpypKAsXc1Zk1WSa37+6bMXWX9b/juWwRJZaznGZ9YjJ2sOZm13eHRqpv339i75GbC0Ajx2stZkbd3dakEv+VFcstNcu0HUTvIxshRo6uUELt9glEfhm4oAshQhozqyjGSoKMhShIzqyDKSoaIgSxEyqiPLSIaKgixFyKiOLCMZKgqyFCGjOrKMZKgoyFKEjOrIMpKhoiBLETKqI8tIhoqCLEXIqI4sIxkqCrIUIaM6soxkqCjIUoSM6sgykqGiIEsRMqojy0iGioIsRciojiwjGSoKshQhozqyjGSoKMhShIzqyDKSoaIgSxEyqiPLSIaKgixFyKiOLCMZKsoXOIgiF3P82hcAAAAASUVORK5CYII=';

// ---- FLIP IMAGE -----------------------------------------------------------------------------------------------------
INKIVE.C.FLIP_IMAGE = {
  HORIZONTAL: 'image-flip-h',
  VERTICAL: 'image-flip-v'
};
// ---- LOCALE FONTS -----------------------------------------------------------------------------------------------------
INKIVE.C.LOCALE_SUBSETS = [
  {
    locales: [],
    name: 'default'
  },
  {
    locales: ['ar'],
    name: 'arabic'
  },
  {
    locales: ['bn'],
    name: 'bengali'
  },
  {
    locales: ['zh'],
    name: 'chinese'
  },
  {
    locales: ['ru', 'az', 'be', 'bg', 'mk', 'kz', 'mn', 'sr', 'tt', 'uk', 'uz', 'ka'],
    name: 'cyrillic'
  },
  {
    locales: ['ne'],
    name: 'devanagari'
  },
  {
    locales: ['el'],
    name: 'greek'
  },
  {
    locales: ['gu'],
    name: 'gujarati'
  },
  {
    locales: ['pa'],
    name: 'gurmukhi'
  },
  {
    locales: ['he'],
    name: 'hebrew'
  },
  {
    locales: ['kn'],
    name: 'kannada'
  },
  {
    locales: ['km'],
    name: 'khmer'
  },
  {
    locales: ['ko'],
    name: 'korean'
  },
  {
    locales: ['ja'],
    name: 'japanese'
  },
  {
    locales: ['es', 'pt', 'de', 'fr', 'it', 'nl'],
    name: 'latin-ext'
  },
  {
    locales: ['ml'],
    name: 'malayalam'
  },
  {
    locales: ['my'],
    name: 'myanmar'
  },
  {
    locales: ['or'],
    name: 'oriya'
  },
  {
    locales: ['si'],
    name: 'sinhala'
  },
  {
    locales: ['ta'],
    name: 'tamil'
  },
  {
    locales: ['te'],
    name: 'telugu'
  },
  {
    locales: ['th'],
    name: 'thai'
  },
  {
    locales: ['vi'],
    name: 'vietnamese'
  }
];

INKIVE.C.SHUTTERSTOCK = 'sstk';
INKIVE.C.DPI = 96;

INKIVE.C.uppy_companion_url = INKIVE.C.IS_QA || INKIVE.C.IS_DEV
  ? 'https://webloaderdev.desygnerapp.com'
  : 'https://uploader.webrand.com';
